export default __webpack_public_path__ + "static/introduce-c0b6c7ea0ce34441160abf3c5bfd59eb.png";